export function getBaseURL() {
  return 'https://adecisioncf.huashikeji.workers.dev'
  // return 'http://127.0.0.1:8787'
}
